var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrap},[(_vm.type === '2')?_c('NameAllot',{attrs:{"branch":_vm.branch}}):_vm._e(),(_vm.type === '0')?_c('DepartmentAllot',{attrs:{"type":"0","branch":_vm.branch}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }